import React, { Component } from "react";
import Header from "./components/structure/Header";
import Content from "./components/structure/Content";
import Resume from "./resume.json";

class App extends Component {
  componentDidMount() {
    document.title = Resume.basics.name;
  }

  render() {
    return (
      <div>
        <Header />
        <Content />
      </div>
    );
  }
}

export default App;
